module.exports = __webpack_public_path__ + "img/icono-noticias.8a237852.svg";